module.exports = __webpack_public_path__ + "static/media/P18.946d4996.jpg";